/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Companies, Users } from "../Data/Const";
import { Button } from "primereact/button";
import { useFetchGetPagination } from "Services/api";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import TempPagination from "Components/Pagination/TempPagination";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";

const UsersTable = (props) => {
  const dt = useRef(null);

  const [usersInformationsUrl, setUsersInformationsUrl] = useState("");

  const usersInformationsQuery = useFetchGetPagination(
    usersInformationsUrl,
    props.auth.token
  );

  const [sortedOrder, setSortedOrder] = useState(null);
  const [sortedField, setSortedField] = useState(null);

  const [filters, setFilters] = useState({
    surname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    firstname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    connectionsNumber: { value: null, matchMode: FilterMatchMode.EQUALS },
    seniority: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const url = new URL(
      `${process.env.REACT_APP_BASE_URL_API}/users/stats/informations`
    );

    //? By default, 25 items per page
    url.searchParams.append("itemsPerPage", 25);

    filters.firstname.value &&
      url.searchParams.append("firstname", filters.firstname.value);
    filters.surname.value &&
      url.searchParams.append("surname", filters.surname.value);
    filters.connectionsNumber.value &&
      url.searchParams.append(
        "connectionsNumber",
        filters.connectionsNumber.value
      );
    filters.seniority.value &&
      url.searchParams.append("seniority", filters.seniority.value);

    sortedField &&
      url.searchParams.append(
        `order[${sortedField}]`,
        sortedOrder === 1 ? "asc" : "desc"
      );

    setUsersInformationsUrl(url);
  }, [filters, sortedField, sortedOrder]);

  useEffect(() => {
    if (usersInformationsQuery.data) {
      setTableData(usersInformationsQuery.data);
    }
  }, [usersInformationsQuery.data]);

  const cols = [
    {
      field: "surname",
      header: "Nom",
      dataType: "name",
      sortable: true,
      filter: true,
    },
    {
      field: "firstname",
      header: "Prénom",
      dataType: "name",
      sortable: true,
      filter: true,
    },
    {
      field: "connectionsNumber",
      header: "Nombre de connexions",
      dataType: "numeric",
      sortable: true,
      filter: true,
    },
    {
      field: "seniority.seniorityLabel",
      header: "Niveau d'éducation",
      dataType: "name",
      sortable: true,
      filter: true,
    },
    {
      field: "charteSignedDate",
      header: "Date d'inscription",
      dataType: "date",
      sortable: true,
      filter: false,
    },
    {
      field: "lastConnectionDate",
      header: "Dernière connexion",
      dataType: "date",
      sortable: true,
      filter: false,
    },
  ];

  const handleSort = (e) => {
    setSortedField(e.sortField);
    setSortedOrder(e.sortOrder);
  };

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportCSV = () => {
    dt.current.exportCSV(tableData);
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, tableData);
        doc.save("stats-informations-utilisateurs.pdf");
      });
    });
  };

  const exportTableExcel = () => {
    return;
  };

  const header = (
    <div className="flex align-items-center export-buttons stats_container__table-tooltip">
      <Button
        type="button"
        icon="pi pi-file"
        onClick={() => exportCSV(false)}
        className="mr-2 csv"
        data-pr-tooltip="CSV"
      />
      <Button
        type="button"
        icon="pi pi-file-excel"
        onClick={exportTableExcel}
        className="p-button-success mr-2 xl"
        data-pr-tooltip="XLS"
      />
      <Button
        type="button"
        icon="pi pi-file-pdf"
        onClick={exportPdf}
        className="p-button-warning mr-2 pdf"
        data-pr-tooltip="PDF"
      />
    </div>
  );

  return (
    <div className="stats_container__table">
      <div className="stats_container__table__forms">
        <h5 className="stats_container__table-title">
          Statistiques sur les utilisateurs
        </h5>
        <br />

        <DataTable
          id="offers-table"
          value={tableData}
          responsiveLayout="scroll"
          sortField={sortedField}
          sortOrder={sortedOrder}
          dataKey="id"
          filters={filters}
          onSort={handleSort}
          onFilter={(e) => setFilters(e.filters)}
          filterDisplay="row"
          loading={!usersInformationsQuery.loaded}
          header={header}
          ref={dt}
        >
          {cols.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              filterMatchMode={
                col.filter
                  ? col.dataType === "date"
                    ? "dateIs"
                    : "contains"
                  : null
              }
              sortable={col.sortable}
              filter={col.filter}
              dataType={col.dataType}
            />
          ))}
        </DataTable>

        <TempPagination
          result={usersInformationsQuery}
          rows={50}
          refItemParent={dt}
        />
      </div>
    </div>
  );
};

UsersTable.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);
